module.exports = __webpack_public_path__ + "static/media/demuth_1.7b037993.png";